import React, { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styles from './Lesson.module.css'

import TopBar from './TopBar/TopBar';
import Body from './Body/Body';
import BottomBar from './BottomBar/BottomBar';
import { saveLastStageIndex, updateScore } from '../../../store/actions';


/* const STAGE_TYPES = {
    VOCABULARY: 1,
    PRACTICE: 2,
    STUDY: 3,
    DIALOG: 4,
    TEXT: 5,
    LISTEN: 6,
    QUIZ: 7,
    ALPHABET: 8,
} */


const Lesson = ({
    lesson,
    scores,
}) => {
    const history = useHistory();

    //const lastStageIndex = useSelector(state => state.lastStageIndex)
    const dispatch = useDispatch();

    const [selectedStage, setSelectedStage] = useState(useSelector(state => state.lastStageIndex))
    const [lastScore, setLastScore] = useState(useSelector(state => state.lastScore));
    const viewPagerEl = useRef();

    const handleChangeView = (index) => {
        setSelectedStage(index)
    }

    const handleChangeViewAndMove = (index) => {
        setSelectedStage(index)
        viewPagerEl.current.scrollTo(index)
    }

    const handleStageClick = (stageKey, index) => {
        dispatch(saveLastStageIndex(index))
        history.push('/course', {
            lessonId: lesson.id,
            stageKey: stageKey,
            page: 'STAGE',
        })
    }

    const checkLastScoreChange = () => {
        if (lastScore !== -2) {
            dispatch(updateScore(lastScore, lesson.id, Number(lesson.stages[selectedStage])))
        }
    }

    useEffect(checkLastScoreChange, [])

    return (
        <div className={styles.container}>
            <TopBar
                title={lesson.name}
                onBackClick={() => {
                    dispatch(saveLastStageIndex(0))
                    history.goBack()
                }} />
            <Body
                viewPagerElement={viewPagerEl}
                stages={lesson.stages}
                onViewChange={handleChangeView}
                onStageClick={handleStageClick}
                scores={scores} />
            <BottomBar
                onIndicatorClick={handleChangeViewAndMove}
                indicatorsNum={lesson.stages.length}
                selectedIndicator={selectedStage} />
        </div>
    )
}

export default Lesson
